'use client'

import type { ReactNode } from 'react'
import {
  PanelsSurfaceProvider,
  type PanelsSkin,
  type PanelsSurface,
} from '@/deskUiSkeletons/Page/PanelsSurfaceContext'
import { MoreLink } from '@/deskUiSkeletons/Shared/Shared'
import { FoldSubsButton } from '@/msgComponents/controls/FoldSubsButton/Modern/FoldSubsButton'
import { PagingBar } from '@/msgComponents/controls/PagingBar/Modern/PagingBar'
import { RefreshSubs } from '@/msgComponents/controls/RefreshSubs/Modern/RefreshSubs'
import { CheckedsInfo } from '@/msgComponents/controls/CheckedsInfo/Modern/CheckedsInfo'
import { mainTemplateVariant, menuTemplateVariant } from '../rowTemplates/RowTemplateConfig'

const wikiPanelsSkin: PanelsSkin = {
  toolbar: 'mb-3 flex min-h-5 items-center',
  toolbarHide: 'cursor-pointer text-xs text-[var(--wiki-muted)] hover:text-[var(--wiki-link)] hover:underline',
  toolbarMessage: 'hidden',
  panelAnswers: 'relative mb-8 flex flex-col bg-[var(--wiki-bg)]',
  panelSubmsges: 'relative mb-8 flex flex-col border-y border-[var(--wiki-border)] bg-[var(--wiki-bg)] py-4',
  panelTools: 'mb-3 flex min-h-7 flex-wrap items-center gap-2',
  rootList: 'm-0 flex list-none flex-col gap-1 p-0',
  sectionInfo: 'mb-3 text-sm font-semibold text-[var(--wiki-text)]',
  sectionInfoCount: 'ml-1 text-[var(--wiki-muted)]',
  menuPanel: 'relative flex-col border-y border-[var(--wiki-border)] bg-[var(--wiki-bg)] py-4',
  menuPanelShown: '!flex',
  menuPanelHidden: '!hidden',
  togglePhoto: 'hidden',
  menuPanelTools: 'mb-3 flex min-h-7 flex-wrap items-center gap-2',
  menuList: 'flex list-none flex-col gap-2 p-0',
  sectionSwitch: 'mb-3 flex w-max gap-1 border border-[var(--wiki-border)] bg-[var(--wiki-subtle)] p-1 text-xs',
  sectionSwitchButton: 'px-3 py-2',
  sectionSwitchButtonActive: 'bg-[var(--wiki-bg)] text-[var(--wiki-link)] shadow-sm',
  sectionSwitchButtonInactive: 'text-[var(--wiki-muted)] hover:bg-[var(--wiki-bg)]',
  menuEmpty: 'px-2 py-4 text-sm text-[var(--wiki-muted)]',
}

const wikiPanelsSurface: PanelsSurface = {
  FoldSubsButton,
  PagingBar,
  RefreshSubs,
  CheckedsInfo,
  MoreLink,
  menuEmptyLabel: 'No pages',
  config: { mainTemplateVariant, menuTemplateVariant },
  skin: wikiPanelsSkin,
}

export function WikiPanelsSurfaceProvider({ children }: { children: ReactNode }) {
  return <PanelsSurfaceProvider value={wikiPanelsSurface}>{children}</PanelsSurfaceProvider>
}
